import React from 'react';

const ContactLink = ({className}) => (
  <svg className={className} viewBox="0 0 21 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7531 1.44922H15.7661C18.1004 1.44922 19.9927 3.34152 19.9927 5.67588C19.9927 8.01009 18.1004 9.90253 15.7661 9.90253H12.7531M8.638 9.90271H5.62504C3.29069 9.90271 1.39844 8.01041 1.39844 5.67606C1.39844 3.34184 3.29069 1.4494 5.62504 1.4494H8.638" stroke="#FDFEFE" strokeWidth="1.40887"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M8.12891 5.49669V5.33594H13.7644V5.49669H8.12891Z" fill="black" fillOpacity="0.01" stroke="#FDFEFE" strokeWidth="1.54836"/>
  </svg>


);

export default ContactLink;
